import {CustomRoleFeatureKeys} from 'src/security/customRoleFeatureKeys';

/**
 * Reabrir tarea (Cerrada / FueraPlazo → Abierta): mismo rol legacy `taskEdit` que edición cerrada,
 * pero en roles custom el feature es `taskReopen`, no `taskEditClosed`.
 * Alineado con stem-web-backend `canReopenTask`.
 */
const REOPEN_FIXED_ROLES = [
  'admin',
  'administrador',
  'administradorOperaciones',
  'taskEdit',
] as const;

export function canUseTaskReopenForUi(
  hasPermissionTareaEditClosed: boolean,
  featureKeys: readonly string[],
  tenantAccessContextLoadStatus: 'loaded' | 'failed' | null | undefined,
  roles?: readonly string[],
): boolean {
  if (hasPermissionTareaEditClosed) {
    return true;
  }
  if (roles?.some((r) => (REOPEN_FIXED_ROLES as readonly string[]).includes(r))) {
    return true;
  }
  if (tenantAccessContextLoadStatus === 'failed') {
    return false;
  }
  return featureKeys.includes(CustomRoleFeatureKeys.taskReopen);
}
